export default __webpack_public_path__ + "static/angryIP-d98d55ffca9496b109d6650007c12ac7.webp";